import { take, call, put, fork, all } from 'redux-saga/effects';
import fetchApi, { uploadImage } from '../../../../../utils/fetchApi';
import Configs from '../../../../../constants/Config';


function* getAllLensFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload: { filter, clearState }, next } = yield take('GET_ALL_LENS');
		if (clearState) {
			yield put({ type: 'RESET_STATE' });
		}
		try {
			const response = yield call(fetchApi, `LensOptions/getAll?filter=${JSON.stringify(filter)}`);
			if (response && !response.error) {
				yield put({ type: 'GET_ALL_LENS_SUCCESS', payload: response });
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

// function* editLensFLow() {
// 	const INFINITE = true;

// 	while (INFINITE) {
// 		const { payload, next } = yield take('EDIT_LENS');
// 		try {
// 			const response = yield call(fetchApi, `LensOptions/${payload.payload.id}`, payload.payload.formData, { method: 'PATCH' });
// 			if (response && !response.error) {
// 				yield put({ type: 'EDIT_LENS_SUCCESS', payload: response });
// 				if (next && typeof next === 'function') {
// 					next();
// 				}
// 			}
// 		} catch (err) {
// 			yield put({ type: 'REQUEST_ERROR', payload: err });
// 		}
// 	}
// }

function* createLensFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload, next } = yield take('CREATE_LENS');
		try {
			if (payload.payload.formData.filePhoto) {
				const formData = new FormData();
				formData.append('file', payload.payload.formData.filePhoto, 'texture.png');

				let s3Bucket = Configs.S3_BUCKET;
				const img = yield call(uploadImage, `attachments/${s3Bucket}/upload`, formData);

				delete payload.payload.formData.texture;
				delete payload.payload.formData.filePhoto;

				if (img && !img.error) {
					payload.payload.formData.texture = `https://${img.result.files.file[0].container}.s3.ap-northeast-1.amazonaws.com/${img.result.files.file[0].name}`;
				}
			}
			const response = yield call(fetchApi, `LensOptions`, payload.payload.formData, { method: 'POST' });
			if (response && !response.error) {
				yield put({ type: 'CREATE_LENS_SUCCESS', payload: response });
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

function* deleteLensFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload, next } = yield take('DELETE_LENS');
		try {
			const reqs = [];
			payload.payload.forEach((el) => {
				reqs.push(call(fetchApi, `LensOptions/${el}`, {}, { method: 'DELETE' }));
			});
			// const response = yield call(fetchApi, `LensOptions/${payload.id}`, {}, { method: 'DELETE' });
			const responses = yield all(reqs);
			if (responses && responses[0] && !responses[0].error) {
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

function* getLensByIdFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload, next } = yield take('GET_LENS_BY_ID');
		try {
			const response = yield call(fetchApi, `LensOptions/${payload.id}`);
			if (response && !response.error) {
				yield put({ type: 'GET_ALL_LENS_SUCCESS', payload: response });
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

function* editLensFLow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload, next } = yield take('EDIT_LENS');
		try {
			if (payload.payload.formData.filePhoto) {
				const formData = new FormData();
				formData.append('file', payload.payload.formData.filePhoto, 'texture.png');

				let s3Bucket = Configs.S3_BUCKET;
				const img = yield call(uploadImage, `attachments/${s3Bucket}/upload`, formData);

				delete payload.payload.formData.texture;
				delete payload.payload.formData.filePhoto;

				if (img && !img.error) {
					payload.payload.formData.texture = `https://${img.result.files.file[0].container}.s3.ap-northeast-1.amazonaws.com/${img.result.files.file[0].name}`;
				}
			}

			const response = yield call(fetchApi, `LensOptions/${payload.payload.id}`, payload.payload.formData, { method: 'PATCH' });
			if (response && !response.error) {
				yield put({ type: 'EDIT_LENS_SUCCESS', payload: response });
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

function* addMultiLensesFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload: { importData }, next } = yield take('ADD_MULTI_LENSES');
		try {
			const createLensReqs = [];
			importData.forEach(data => {
				createLensReqs.push(call(fetchApi, 'LensOptions', data, { method: 'POST' }));
			});

			const responses = yield all(createLensReqs);

			if (responses && responses[0] && !responses[0].error) {
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

export function* lensListFlow() {
	yield fork(getAllLensFlow);
	yield fork(editLensFLow);
	yield fork(createLensFlow);
	yield fork(deleteLensFlow);
	yield fork(getLensByIdFlow);
	yield fork(addMultiLensesFlow);
}



// WEBPACK FOOTER //
// ./routes/app/routes/lens-list/saga/list.js